(function () {
  "use strict";

  function buildDetailHtml(btn) {
    var number = btn.getAttribute("data-pf-number") || "";
    var name = btn.getAttribute("data-pf-name") || "";
    var note = btn.getAttribute("data-pf-note") || "";
    var productUrl = btn.getAttribute("data-pf-product-url") || "";
    var productTitle = btn.getAttribute("data-pf-product-title") || "";
    var productPrice = btn.getAttribute("data-pf-product-price") || "";
    var altUrl = btn.getAttribute("data-pf-alt-url") || "";
    var altTitle = btn.getAttribute("data-pf-alt-title") || "";
    var altPrice = btn.getAttribute("data-pf-alt-price") || "";
    var contactHref = btn.getAttribute("data-pf-contact-href") || "";

    var html = '<h3 class="pf-detail-title"><span class="pf-detail-number">' + number + '</span>' + name + '</h3>';
    if (note) {
      html += '<p class="pf-detail-note">' + note + '</p>';
    }
    html += '<div class="pf-detail-links">';
    if (productUrl) {
      html += '<a class="pf-buy-btn" href="' + productUrl + '"><span>' + productTitle + '</span><span class="pf-buy-btn__price">' + productPrice + '</span></a>';
    }
    if (altUrl) {
      html += '<a class="pf-buy-btn" href="' + altUrl + '"><span>' + altTitle + '</span><span class="pf-buy-btn__price">' + altPrice + '</span></a>';
    }
    if (!productUrl && contactHref) {
      html += '<a class="pf-contact-btn" href="' + contactHref + '">Not sold separately — contact us</a>';
    }
    html += '</div>';
    return html;
  }

  function initDiagram(root) {
    var panel = root.querySelector('[data-pf-panel]');
    var hotspots = root.querySelectorAll('.pf-hotspot');
    if (!panel || !hotspots.length) return;

    hotspots.forEach(function (btn) {
      btn.addEventListener('click', function () {
        hotspots.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        panel.innerHTML = buildDetailHtml(btn);
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: false });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pf-diagram]').forEach(initDiagram);
  });
})();
